export default __webpack_public_path__ + "static/media/BrainBreak cards72.f50244b3.png";